import { BaseApi } from "./BaseApi";

export class FreteApi extends BaseApi {
    
    async buscarTiposFreteAtivos() : Promise<FreteApi.BuscarTiposFreteAtivosRespostaItem[]> {
        return (await this.api.get(`/Frete/BuscarTiposFreteAtivos`)).data
    }
}

export namespace FreteApi {
    export type BuscarTiposFreteAtivosRespostaItem = {
        Id?:number
        Descricao?:string
    }
}
